// Obtenemos Vue
import Vue from "vue";
import store from "./store.js";
// Obtenemos el paquete
import VueRouter from "vue-router";


import Home from "./components/Index.vue";
import Faqs from "./components/Faqs.vue";

// Profile
import Login from "./components/profile/loginComponent.vue";
import Register from "./components/profile/registerComponent.vue";
import Forgot from "./components/profile/forgotComponent.vue";
import Recover from "./components/profile/recoverComponent.vue";
import Activate from "./components/profile/activeComponent.vue";
import ResendAccessCode from "./components/profile/resendAccessCodeComponent.vue";

import Albumes from "./components/Albumes.vue";
import Gallery from "./components/Gallery.vue";
// Carrito
import Cart from "./components/payment/CartComponent.vue";
import SuccessPayment from "./components/payment/SuccessPayment.vue";
import CardChallenge from "./components/Challenge.vue";

Vue.use(VueRouter);

// Definimos las rutas
const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/es",
        name: "es.home",
        component: Home,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/faqs",
        name: "faqs",
        component: Faqs,
        meta: {
            // disableIfLoggedIn: true,
        },
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        redirect: { name: "home" },
        meta: {
            disableIfLoggedIn: true,
        },
    },
    {
        path: "/register",
        name: "register",
        component: Register,
        meta: {
            disableIfLoggedIn: true,
        },
    },
    {
        path: "/forgot",
        name: "forgot",
        component: Forgot,
        meta: {
            disableIfLoggedIn: true,
        },
    },
    {
        path: "/recover",
        name: "recover",
        component: Recover,
        meta: {
            disableIfLoggedIn: true,
        },
    },
    {
        path: "/activate",
        name: "activate",
        component: Activate,
        meta: {
            disableIfLoggedIn: true,
        },
    },
    {
        path: "/resendaccesscode",
        name: "resendAccessCode",
        component: ResendAccessCode,
        meta: {
            disableIfLoggedIn: true,
        },
    },
    {
        path: "/albumes",
        name: "albumes",
        component: Albumes,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/gallery",
        name: "gallery",
        component: Gallery,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/payment",
        name: "payment",
        component: Cart,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/successful-payment/:dsSalesId/:existingSale?",
        name: "success_payment",
        component: SuccessPayment,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/cart/challenge",
        name: "challenge",
        component: CardChallenge,
        meta: {},
    },
    {
        path: "/404",
        component: () => import("./components/page_404.vue"),
    },
    {
        path: "/es/404",
        component: () => import("./components/page_404.vue"),
    },
    { path: "*", redirect: "/404" },
];

// Generamos la instancia
const router = new VueRouter({
    base: '',
    mode: 'history',
    routes,
});

export default router;